import TariffsTable from './TariffsTable';

export { TariffsTable };


// WEBPACK FOOTER //
// ./src/modules/home/tariffsTable/index.js